import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StakeholderInterfacesEditor } from "./product/StakeholderInterfacesEditor";
import { ProductFeaturesEditor } from "./product/ProductFeaturesEditor";
import { RoadmapEditor } from "./product/RoadmapEditor";
import { EditorHeader } from "./EditorHeader";

export const ProductEditor = () => {
  return (
    <div className="space-y-6">
      <EditorHeader title="Product Editor" />
      
      <Tabs defaultValue="interfaces" className="space-y-6">
        <TabsList className="grid grid-cols-3 w-full">
          <TabsTrigger value="interfaces">Stakeholder Interfaces</TabsTrigger>
          <TabsTrigger value="features">Product Features</TabsTrigger>
          <TabsTrigger value="roadmap">Product Roadmap</TabsTrigger>
        </TabsList>

        <TabsContent value="interfaces">
          <StakeholderInterfacesEditor />
        </TabsContent>

        <TabsContent value="features">
          <ProductFeaturesEditor />
        </TabsContent>

        <TabsContent value="roadmap">
          <RoadmapEditor />
        </TabsContent>
      </Tabs>
    </div>
  );
};